<div [class]="data().rootClasses" class="form-root" [style]="data().rootVars">
    <form style="pointer-events: none">
        <div class="form-fields-container">
            @for (control of data().elements; track $index) {
                <div [class]="data().fieldClasses" class="form-field">
                    <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                    <input
                        [class]="data().fieldClasses"
                        class="form-control"
                        [attr.type]="$any(control).htmlInputType"
                        [attr.placeholder]="$any(control).placeholder"
                    />
                </div>
            }

            <div class="form-button-wrapper login-edu-button-wrapper" [style]="data().wrapperVars">
                <a class="common-form-btn" [class]="data().buttonClasses" [style]="data().buttonVars">
                    {{ data().buttonLabel }}
                </a>
            </div>

            @if (showRegistrationFormLink()) {
                <a class="login-edu-link">{{ "go_to_register" | translate }} &#8594; </a>
            }
        </div>
    </form>
</div>
